export const AT_ACTIVITIES_INIT = 'ACTIVITIES_ACTIVITIES_INIT';
export const AT_ACTIVITIES_ADD = 'ACTIVITIES_ACTIVITIES_ADD';
export const AT_ACTIVITIES_UPDATE = 'ACTIVITIES_ACTIVITIES_UPDATE';
